// extracted by mini-css-extract-plugin
module.exports = {"Seprator":"CreditSortModal_Seprator__2ooZ9","SubmitButton":"CreditSortModal_SubmitButton__1TdFh"};